/* eslint consistent-return: 0 eqeqeq: 0 */

/**
 * @public
 * Gets the first value associated to an object's property.
 * Can go recursively through objects and arrays.
 *
 * @see https://gist.github.com/jherax/8dd257d5c4159c9b6df4
 *
 * @param  {Object|Array} obj: the object or array to look for the property/index value
 * @param  {String|Number} key: the object's property name or array index
 * @return {any}
 */
export default function getValueByKey(obj, key) {
  let value;
  for (const prop in obj) {
    if (prop == key) return obj[prop];
    if (obj[prop] instanceof Object) {
      value = getValueByKey(obj[prop], key);
      if (value !== undefined) return value;
    }
  }
}
